export const keys = {
    all: ["alarm-scheme-admin"],

    referenceData: (groupID: number, 
        organizationID: number

    ) => [
        ...keys.all,
        "referencedata", {
            groupID,
            organizationID         
            }
    ],
    getAlarmScheme: (
        organizationID: number | undefined,
        groupID: number,
        alarmSchemeID: number | undefined,
        
    ) => [
        ...keys.all,
        "getAlarmScheme", {
            organizationID,
            groupID,
            alarmSchemeID,
        }
    ],
    alarmSchemes: (
        organizationID: number | undefined,
        groupID: number
        ) => [
            ...keys.all,
            "alarmschemes", {
                organizationID,
                groupID,
            }
        ],
};

